module.exports = __webpack_public_path__ + "static/spectrum-74bf61e1058144746a7ae92c1e45ea6a.mp3";